import autoTable from 'jspdf-autotable';
import jsPDF from 'jspdf';
import { Fragment, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import Select from 'react-select';

import RelatorioFeriasContent from './rFeriasContent';
import { TipoPeriodoDescanso } from '../enums/tipo-periodo-descanso.enum';
import PrintComponent from '@/shared/components/PrintComponent';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import { exportFromTableToExcel } from '@/shared/utils/xlsx';
import imprimirDiv from '@/shared/utils/impressao';

const OPCOES_TIPOS_EVENTO = [
  { value: TipoPeriodoDescanso.Ferias, label: 'Férias' },
  { value: TipoPeriodoDescanso.FolgaNatalicia, label: 'Folga Natalícia' },
  { value: TipoPeriodoDescanso.AbonoTrabalhado, label: 'Abono Trabalhado' },
  { value: TipoPeriodoDescanso.AbonoEspecial, label: 'Abono Especial' },
  { value: TipoPeriodoDescanso.LicencaPremio, label: 'Licença Prêmio' },
  { value: TipoPeriodoDescanso.LicencaOutros, label: 'Afastado' },
  { value: TipoPeriodoDescanso.Afastamento, label: 'Afastamento' },
];

const TABELA_ID = 'tabela';
const CONTEUDO_ID = 'conteudo';

export default function RelatorioFeriasHeader() {
  const { setActions } = useBreadcrumbActions();
  const contentRef = useRef<HTMLDivElement>(null);
  const reactToPrintFn = useReactToPrint({ contentRef });

  const [todoperiodo, setTodoperiodo] = useState<boolean>(true);
  const [tiposEventos, setTiposEventos] = useState<{ value: number; label: string }[]>([]);
  const [dataInicial, setDataInicial] = useState<string>('');
  const [dataFinal, setDataFinal] = useState<string>('');

  const tiposValores = useMemo(() => tiposEventos.map((t) => t.value), [tiposEventos]);

  const imprimirJspf = useCallback(() => {
    const doc = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4',
    });

    doc.text(
      'Relatório de Registros',
      doc.internal.pageSize.getWidth() / 2,
      10,
      { align: 'center' },
    );
    doc.setFontSize(12);

    autoTable(doc, {
      startY: 20,
      html: '#' + TABELA_ID,
      margin: { top: 15 },
    });

    doc.save('relatorio_ferias.pdf');
  }, []);

  useEffect(() => {
    setActions({
      print: {
        label: 'Exportar',
        onClick: () => {},
        dropdownOptions: [
          { label: 'Excel', onClick: () => exportFromTableToExcel(TABELA_ID, 'relatorio_ferias.xlsx') },
          { label: 'PDF em Tabela', onClick: imprimirJspf },
          { label: 'PDF Completo', onClick: () => reactToPrintFn() },
          { label: 'Imprimir', onClick: () => imprimirDiv(CONTEUDO_ID) },
        ],
      },
    });
    return () => setActions({});
  }, [setActions, imprimirJspf, reactToPrintFn]);

  return (
    <Fragment>
      <div className="row">
        <div className="col-12 d-print-none">
          <h3 className="pt-4">Relatório</h3>
          <span className="blockquote-footer pb-4 text-end">
            Tabela de lotações e situação atual dos defensores.
          </span>
        </div>
        <hr />
        <div className="ms-3 col-auto form-check">
          <input
            id="historico"
            className="form-check-input"
            title="Exibir todo o histórico"
            type="checkbox"
            checked={todoperiodo}
            onChange={() => {
              setTodoperiodo(!todoperiodo);
            }}
          />
          <label htmlFor="historico" className="form-check-label">
            Histórico Completo
          </label>
        </div>
        <div className="col-auto">
          <label htmlFor="tipos-evento" className="form-label me-2">
            Tipos de evento:
          </label>
          <Select
            id="tipos-evento"
            isMulti
            options={OPCOES_TIPOS_EVENTO}
            value={tiposEventos}
            onChange={(v) => setTiposEventos(v ? [...v] : [])}
            placeholder="Todos (se vazio)"
            className="d-inline-block"
            styles={{ container: (base) => ({ ...base, minWidth: 280 }) }}
          />
        </div>
        <div className="col-auto">
          <label htmlFor="data-inicial" className="form-label me-1">Data inicial:</label>
          <input
            id="data-inicial"
            type="date"
            className="form-control form-control-sm d-inline-block"
            style={{ width: 'auto' }}
            value={dataInicial}
            onChange={(e) => setDataInicial(e.target.value)}
          />
        </div>
        <div className="col-auto">
          <label htmlFor="data-final" className="form-label me-1">Data final:</label>
          <input
            id="data-final"
            type="date"
            className="form-control form-control-sm d-inline-block"
            style={{ width: 'auto' }}
            value={dataFinal}
            onChange={(e) => setDataFinal(e.target.value)}
          />
        </div>
      </div>
      <PrintComponent
        ref={contentRef}
        value={RelatorioFeriasContent({
          todoperiodo,
          tiposEventos: tiposValores,
          dataInicial: dataInicial || undefined,
          dataFinal: dataFinal || undefined,
        })}
      />
    </Fragment>
  );
}
